import product from './product.js';

export default (cart) => ({
	event: 'purchase',
	cartLocale: cart.url.locale,
	pageName: cart.page.tracking,
	paymentMethod: cart.payment.name,
	transactionRevenueUSD: cart.order.price.street.unformatted,
	ecommerce: {
		currencyCode: cart.order.currency,
		purchase: {
			products: cart.order.products.map(product), // Create array of products
			actionField: {
				id: cart.order.id,
				affiliation: cart.url.hostname,
				revenue: cart.order.price.street.unformatted,
				tax: cart.order.price.tax.unformatted,
				coupon: cart.order.campaign
			}
		}
	},
	orderId: cart.order.id,
	contentGroup: cart.order.contentGroup
});
